export const enum Geometry {
  BoundaryPointX = 600,
  BoundaryPointY = 600,
  GameObjectSize = 20,
  SnakeLength = 8,
}
